function gf_postalcode_autocomplete_fetch( postal_code, house_number, { parent_street, parent_location } ) {
    return $.ajax({
        type : 'post',
        dataType : 'json',
        url : gf_connectned_afas.ajax_url,
        data : {
            action: 'afas_get_address',
            security: gf_connectned_afas.nonce,
            postcode: postal_code,
            house_number: house_number
        },
        beforeSend: function() {
            parent_street.addClass('cn-address--loading');
            parent_location.addClass('cn-address--loading');

            parent_street.removeClass('cn-address--failed');
            parent_location.removeClass('cn-address--failed');

            parent_street.removeClass('cn-address--success');
            parent_location.removeClass('cn-address--success');
        },

        complete: function() {
            parent_street.removeClass('cn-address--loading');
            parent_location.removeClass('cn-address--loading');
        },
    });
}

jQuery( '.cn-address--postal-code input' ).on( 'keydown', function( e ) {
    if( e.keyCode === 13 ) {
        e.preventDefault();
        $(this).closest('.cn-address--postal-code').next().find('input').focus();
    }
});

jQuery( '.cn-address--house-number input' ).on( 'keydown', function( e ) {
    if( e.keyCode === 13 ) {
        e.preventDefault();
        $(this).closest('.cn-address--house-number').next().find('input').focus();
    }
});


jQuery( 'body' ).on( 'keydown', function( e ) {
    let allow_enter = true;
    let address_fields = document.querySelectorAll('[class*="cn-address--"][data-conditional-logic="visible"], [class*="cn-address--"]:not([data-conditional-logic])');

    address_fields.forEach(function(field) {
        let input = field.querySelector('input');
        if( input.value.length === 0 ) {
            allow_enter = false;
        }
    });

    if( e.keyCode === 13 && allow_enter === false) {
        e.preventDefault();
    }
});



gform.addAction( 'gform_input_change', function( elem, formId, fieldId )
{
    /**
     * Get the field
     * @type {*|jQuery}
     */
    let field = jQuery( elem ).closest( '.gfield' );

    let postal_code = null;
    let house_number = null;

    let street_field = null;
    let location_field = null;

    /**
     * Get the class of the field
     */
    let fieldClass = field.attr( 'class' );

    if( fieldClass.includes( 'cn-address--postal-code' ) || fieldClass.includes( 'cn-address--house-number' ) ) {
        let group = fieldClass.match(/cn-field-group--\w+/g);
        if( group ) {
            group = group[0];

            postal_code = jQuery( '.cn-address--postal-code.' + group + ' input' ).val();
            house_number = jQuery( '.cn-address--house-number.' + group + ' input' ).val();

            street_field = jQuery( '.cn-address--street.' + group + ' input' );
            location_field = jQuery( '.cn-address--location.' + group + ' input' );
        }
    }

    if( postal_code && house_number ) {
        if (postal_code.length === 6 && house_number.length >= 1) {
            postal_code = postal_code.toUpperCase();

            if(postal_code.match(/^[1-9][0-9]{3}[A-Z]{2}$/) === null) {
                return;
            }

            let parent_street = street_field.closest('div');
            let parent_location = location_field.closest('div');
            let fetch = gf_postalcode_autocomplete_fetch(postal_code, house_number, { parent_street, parent_location });
            fetch.done(function (response) {
                if (response.success) {
                    let address = response.data;

                    street_field.val(address.street);
                    location_field.val(address.settlement);

                    parent_street.removeClass('cn-address--failed');
                    parent_location.removeClass('cn-address--failed');

                    parent_street.addClass('cn-address--success');
                    parent_location.addClass('cn-address--success');
                }
                else {
                    parent_street.removeClass('cn-address--success');
                    parent_location.removeClass('cn-address--success');

                    parent_street.addClass('cn-address--failed');
                    parent_location.addClass('cn-address--failed');
                }
            });
        }
    }
}, 10, 3 );